import { styled } from 'styled-components';

export const StyleContainer = styled.div`
  margin: 0 auto;
`;

export const StyleDescription = styled.p`
  text-align: center;
  color: var(--pcm-body-color-secondary);
  margin-top: 12px;
  width: 90%;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 30px;
  line-height: 1.2;
`;

export const StyleFeatureList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin-bottom: 34px;
`;

export const StyleFeatureItem = styled.li`
  display: flex;
  align-items: flex-start;
  margin-bottom: 26px;
  gap: 12px;
  svg {
    color: var(--pcm-body-color);
    circle {
      fill: var(--pcm-body-color-secondary);
    }
  }
`;

export const StyleIcon = styled.span`
  font-size: 24px;
  margin-right: 16px;
`;

export const StyleFeatureContent = styled.div`
  flex: 1;
`;

export const StyleFeatureTitle = styled.h3`
  font-size: 14px;
  margin-bottom: 4px;
`;

export const StyleFeatureDescription = styled.p`
  color: var(--pcm-body-color-secondary);
  line-height: 1.2;
  margin: 0;
  font-size: 14px;
`;

export const StyleWarning = styled.div`
  display: flex;
  align-items: flex-start;
  border-radius: 4px;
  margin-bottom: 34px;
  gap: 10px;
  line-height: 1.2;
  font-size: 14px;

  svg {
    width: 18px;
    height: 18px;
    path {
      fill: #f4940e;
    }
  }
`;

export const StyleWarningIcon = styled.span`
  font-size: 24px;
  margin-right: 12px;
`;

export const StyleWarningText = styled.p`
  margin: 0;
`;
